import React, {useEffect, useState} from "react";
import Page from "../../layout/Page";
import {useNavigate, useParams} from "react-router-dom";
import dailyListService from "../../service/DailyListService";
import Container from "@mui/material/Container";
import {useTranslation} from "react-i18next";
import PageActions from "../../components/PageActions";
import {FormProvider, useForm} from "react-hook-form";
import {MessageType} from "../../util/Enums";
import useMessage from "../../util/useMessage";
import BackButton from "../../ui/BackButton";
import SaveButton from "../../ui/SaveButton";
import DailyListEditInputPanel from "./DailyListEditInputPanel";
import DailyListEditMatchTable from "./DailyListEditMatchTable";
import Grid from '@mui/material/Grid';

const DailyListEditPage = ({title}) => {

    const param = useParams();
    const dailyListId = param?.id;

    const {t} = useTranslation();
    const navigate = useNavigate();
    const showMessage = useMessage();

    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);

    const [dailyList, setDailyList] = useState(null);

    const methods = useForm();


    useEffect(() => {
        let mount = true;
        if (dailyListId) {
            (async () => {
                setPageLoading(true);
                try {
                    const [_result] = await Promise.all([
                        dailyListService.get(dailyListId),
                    ]);
                    mount && initPageValues(_result);
                } catch (e) {
                    console.error(e);
                } finally {
                    mount && setPageLoading(false);
                }
            })();
        } else {
            setPageLoading(false);
        }
        return () => {
            return () => mount = false;
        }
    }, [dailyListId]);

    const initPageValues = (_dailyList) => {
        setDailyList(_dailyList);
        methods.setValue("application", _dailyList.application);
    }

    const onSubmit = async (data) => {

        if (loading) return false;
        try {
            setLoading(true);

            const obj = {
                id: dailyListId | null,
                ...data,
            }
            const resultObject = await dailyListService.saveOrUpdate(dailyListId, obj);
            showMessage(t(dailyListId ? 'message.updated' : 'message.created'));

            if (!dailyListId) {
                navigate(`/daily-lists/edit/${resultObject._id}`, {replace: true});
            } else {
                initPageValues(resultObject);
            }

        } catch ({code, message}) {
            showMessage(`${code} - ${message}`, MessageType.ERROR);
        } finally {
            setLoading(false);
        }
    }

    const ActionPanel = () => (
        <PageActions>
            <BackButton loading={loading}/>
            <SaveButton loading={loading}/>
        </PageActions>
    );

    const checkKeyDown = (e) => {
        if (e.key === "Enter") e.preventDefault();
    };


    return (
        <Page title={title} loading={pageLoading}>
            <Container maxWidth={"xl"}>
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
                        <ActionPanel/>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={12}>
                                <DailyListEditInputPanel dailyList={dailyList}/>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <DailyListEditMatchTable dailyList={dailyList}/>
                            </Grid>
                        </Grid>
                        <ActionPanel/>
                    </form>
                </FormProvider>
            </Container>
        </Page>
    );

}

export default DailyListEditPage;
